import vm from '@/main' ///导入VUE实例
import store from 'store/index' ///导入公共仓库
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'

///公共的设备（除面板）控制请求服务端的公共方法：userControlData：用户设置的数据  objData：服务端返回的设备信息数据
const controlBtnRequestHandle = (
  userControlData,
  objData,
  userpassWord = ''
) => {
  // console.log("确定按钮点下了");
  vm.$request({
    method: 'post',
    url: '/device/updateDeiviceControl',
    data: {
      token: store.state.token,
      deviceId: objData.deviceId,
      openState: userControlData.openState,
      openStateValue: userControlData.openStateValue,
      openStateValue1: userControlData.openStateValue1,
      openStateValue2: userControlData.openStateValue2,
      openStateValue3: userControlData.openStateValue3,

      password: userpassWord /////加密的设备需要用到的字段
    }
  })
    .then(res => {
      // console.log(res);
      // vm.$toast(res.data.message, 5000); ///服务端返回信息
      if (res.data.code != 0) {
        console.log('shezhishibai')
        vm.$showTipsToast(3, res.data.message)
        ////说明信息填写错误,控制失败了，需要把原始的服务器数据更新到用户数据
        userControlData.openState = objData.openState
        userControlData.openStateValue = objData.openStateValue
        userControlData.openStateValue1 = objData.openStateValue1
        userControlData.openStateValue2 = objData.openStateValue2
        userControlData.openStateValue3 = objData.openStateValue3

        return
      } else {
        ////、控制成功了需要更新下服务器传来的数据
        console.log(res.data)
        objData.openState = userControlData.openState
        objData.openStateValue = userControlData.openStateValue
        objData.openStateValue1 = userControlData.openStateValue1
        objData.openStateValue2 = userControlData.openStateValue2
        objData.openStateValue3 = userControlData.openStateValue3
        // 代号20200731-1
        if (
          publicDeviceTypeJudge(
            objData.productCode,
            '01',
            '021',
            '05',
            '014',
            '024',
            '023',
            '025',
            '026',
            '029',
            '06',
            '010',
            '015',
            '022',
            '048',//代号 20231207-1
            '049'//代号 20231207-1
          )
        ) {
          ///判断是否是开关类的设备或不需要显示控制成功图标的设备
          ///开关类的设备或不需要显示控制成功图标的设备
          // vm.$showTipsToast(1, "设置成功" ,true);
        } else {
          vm.$showTipsToast(1, '控制成功', true)
        }
      }
    })
    .catch(error => {
      console.log(error)
      ////说明信息填写错误,控制失败了，需要把原始的服务器数据更新到用户数据
      userControlData.openState = objData.openState
      userControlData.openStateValue = objData.openStateValue
      userControlData.openStateValue1 = objData.openStateValue1
      userControlData.openStateValue2 = objData.openStateValue2
      userControlData.openStateValue3 = objData.openStateValue3
    })
}
///面板按键控制请求服务端的公共方法： objData：服务端返回的单个面板设备的单个按键的信息数据dtList
const controlMianBanBtnRequestHandle = objData => {
  // console.log(objData.deviceId);
  vm.$request({
    method: 'post',
    url: '/device/updateDeiviceControl',
    data: {
      token: store.state.token,
      deviceId: objData.deviceId,
      openState: 0,
      openStateValue: 0,
      openStateValue1: 0,
      openStateValue2: 0
    }
  })
    .then(res => {
      // console.log(res);
      // vm.$toast(res.data.message, 5000); ///服务端返回信息
      if (res.data.code != 0) {
        console.log('shezhishibai')
        vm.$showTipsToast(3, res.data.message)
        ////说明信息填写错误,控制失败了，需要把原始的服务器数据更新到用户数据

        return
      } else {
        ////、控制成功了需要更新下服务器传来的数据
        vm.$showTipsToast(1, '控制成功', true)
      }
    })
    .catch(error => {
      console.log(error)
    })
}
export { controlBtnRequestHandle, controlMianBanBtnRequestHandle }
